/* global $ */
/* global URLS */
/* global gettext */

(function (scope) {
  "use strict";

  // proxy configurations
  var materialMap;
  var defaultMaterialMap;
  var materialBetaMap;
  var materialTranslations;
  var materialDescriptions;
  var materialThumbnails;
  var finishThumbnails;
  var colorThumbnails;
  var materialTranslationsLong;
  var platedThickness;
  var materialUrls;

  var disabledProcess = [];

  var PrintMaterialCollection = (scope.PrintMaterialCollection = function (
    controller,
    materials,
    design
  ) {
    materialMap = scope.MaterialConfiguration.materialMap;
    materialBetaMap = scope.MaterialConfiguration.materialBetaMap;
    defaultMaterialMap = scope.MaterialConfiguration.defaultMaterialMap || {};
    materialTranslations = scope.MaterialConfiguration.materialTranslations;
    materialDescriptions = scope.MaterialConfiguration.materialDescriptions;
    materialThumbnails = scope.MaterialConfiguration.materialThumbnails;
    colorThumbnails = scope.MaterialConfiguration.colorThumbnails;
    materialTranslationsLong =
      scope.MaterialConfiguration.materialTranslationsLong;
    finishThumbnails = scope.MaterialConfiguration.finishThumbnails;
    platedThickness = scope.MaterialConfiguration.platedThickness || {};
    materialUrls = window.materialUrls;

    this.controller = controller;
    this.materials = materials;
    this.design = design;
    this.priceMap = {};
    this.pricesAndDefaultQuantities = {
      prices: [],
      quantities: {},
    };
    this.pricesAndDefaultQuantitiesForAllMaterials = {
      prices: [],
      quantities: {},
    };
    this.is_fetching_all_materials = false;

    this.currentMaterialMap = null;
    this.defaultTexts = [
      [gettext("Process"), gettext("Select your process"), "process"],
      [gettext("Material"), gettext("Select your material"), "material"],
      [gettext("Finish"), gettext("Select your finish"), "finish"],
      [gettext("Colors"), gettext("Select your color"), "color"],
      [gettext("Varnish"), gettext("Select your varnish"), "varnish"],
      [gettext("Infill"), gettext("Select your infill"), "infill"],
    ];
    this.currentDesign = null; // used for addLabel food contact
  });

  PrintMaterialCollection.prototype = Object.create(
    scope.BatchControlMixin.prototype
  );

  /**
   * Whether a material map has an infill field, the last one of a 3D front slug.
   * Ex: 'fused_filament_fabrication,fdm_pla,raw,black,,infill_20' has one.
   *
   * @param {string} map
   * @return {boolean}
   */
  var hasInfillField = function (map) {
    return !!map && !!map.split(",")[5];
  };

  PrintMaterialCollection.prototype.getInfill = function (design) {
    if (
      design.order.options &&
      design.order.options.length == 1 &&
      typeof design.order.options[0] == "string" &&
      design.order.options[0].includes("infill")
    ) {
      return design.order.options[0];
    } else {
      return "";
    }
  };

  PrintMaterialCollection.prototype.getCurrentMaterialMap = function (design) {
    var d = design || this.design;
    return d.currentMaterial;
  };

  PrintMaterialCollection.prototype.setDefaultMaterialMap = function (map) {
    defaultMaterialMap = scope.MaterialConfiguration.defaultMaterialMap;
  };

  /**
   * Compute prices and eventually delays for a design.
   * If computeDelays is set to false, we retrieve prices for all materials. Otherwise, only the currently selected one.
   * If design is set, prices are computed only for it. Otherwise, use the current design or parts. Used for multiple print.
   *
   * @param {boolean} computeDelays
   * @param {Design} array of designs (optional)
   * @param {string} materials to request (optional)
   * @param {boolean} packing_position whether to return packing positions is relevant (optional)
   * @return $.Deferred
   */
  PrintMaterialCollection.prototype.computePricesAndDelays = function (
    computeDelays,
    designs,
    materials,
    packing_positions
  ) {
    var parts =
      designs ||
      (this.design.explode
        ? Object.values(this.design.partitioning.parts)
        : [this.design]);
    var data = {};
    // Build query parameters
    for (var k = 0; k < parts.length; k++) {
      var part = parts[k];
      if (part.model_uuid) {
        data["editinfo_" + k] = part.model_uuid;
      } else {
        data["uuid_" + k] = part.design_uuid;
      }
      if (part.size.size_id) {
        data["size_" + k] = part.size.size_id;
      }

      data["quantity_" + k] = part.order.quantity;
      data["scale_" + k] = part.size.userScale;
      data["unit_" + k] = part.size.unit;
      data["material_" + k] =
        materials || (computeDelays ? part.material.slug : "*");
      data["currency_" + k] = part.order.currency;
      data["finish_" + k] = part.order.finish;
      data["painting_" + k] = part.order.painting;
      data["color_" + k] = part.order.color;
    }

    // Details form TODO: also used by addtocart
    const $details_form = $(".PrintDetailsForm");
    if (
      $details_form.length &&
      $details_form.find("input[name='submitted']").val() === "1"
    ) {
      data.details = $details_form.serialize();
    } else {
      data.details = "";
    }

    if (packing_positions) {
      data["packing_positions"] = 1;
    }

    if (!computeDelays) {
      data.no_delays = "1";
    }
    // In case of multipart prefer a post,
    // we don't limit the number of part but
    // the size of url / headers is limited
    // this way parameters do not appear in
    // the url and don't take space
    var meth;
    if (parts.length < 2) {
      meth = waitForJob.retryGetOnJob;
    } else {
      meth = waitForJob.retryPostOnJob;
    }

    return meth(URLS.x_get_price, data).then(
      function (response) {
        this.rawPrices = response;

        // Let's build a map of prices for easier access.
        for (var i = 0; i < response.length; i++) {
          this.priceMap[response[i].uuid] =
            this.priceMap[response[i].uuid] || {};
          for (var j = 0; j < response[i].price.length; j++) {
            this.priceMap[response[i].uuid][response[i].price[j].material] =
              response[i].price[j];
          }
        }
      }.bind(this)
    );
  };

  /**
   * Clear cached prices.
   *
   * Useful when changing currencies to remove prices from selectors as they are being computed.
   */
  PrintMaterialCollection.prototype.clearPrices = function () {
    this.priceMap = {};
  };

  PrintMaterialCollection.prototype.getDelivery = function (
    design,
    material,
    finish,
    painting
  ) {
    var data = this.getPricesForMaterial(material, design);
    if (!data || !data.delivery) {
      return "";
    }

    // TODO: only used in one place / reuse PriceDataUtils

    // For standard mode, options surely have a further delay than the raw object. We display the maximum
    // found date corresponding to the current options.
    var standardDateText = data.delivery.receipt_date;
    var standardDate = Date.parse(data.delivery.receipt_date_iso);

    if (
      finish &&
      data.options &&
      data.options.finish &&
      data.options.finish[finish] &&
      data.options.finish[finish].delivery
    ) {
      var finishDate = Date.parse(
        data.options.finish[finish].delivery.receipt_date_iso
      );
      if (finishDate > standardDate) {
        standardDate = finishDate;
        standardDateText = data.options.finish[finish].delivery.receipt_date;
      }
    }
    if (
      painting &&
      data.options &&
      data.options.painting &&
      data.options.painting[painting] &&
      data.options.painting[painting].delivery
    ) {
      var finishDate = Date.parse(
        data.options.painting[painting].delivery.receipt_date_iso
      );
      if (finishDate > standardDate) {
        standardDate = finishDate;
        standardDateText =
          data.options.painting[painting].delivery.receipt_date;
      }
    }

    return standardDateText;
  };

  PrintMaterialCollection.prototype.getPricesForMaterial = function (
    material,
    design
  ) {
    var pricesForDesign = this.getPricesForDesign(design || this.design);
    return pricesForDesign ? pricesForDesign[material.slug] : null;
  };

  PrintMaterialCollection.prototype.getPricesForDesign = function (design) {
    return this.priceMap[design.model_uuid];
  };

  PrintMaterialCollection.prototype.getPricesByQuantityForMaterial =
    function () {
      return this.pricesAndDefaultQuantities;
    };

  PrintMaterialCollection.prototype.getPricesForAllMaterials = function (
    material,
    quantity
  ) {
    if (
      this.pricesAndDefaultQuantitiesForAllMaterials.prices.length < 1 ||
      !this.pricesAndDefaultQuantitiesForAllMaterials.prices[quantity]
    )
      return null;
    var ret = this.pricesAndDefaultQuantitiesForAllMaterials.prices[
      quantity
    ].filter(function (price) {
      return price.material == material.slug;
    });
    return ret.length == 0 ? null : ret[0];
  };

  /**
   * Generate HTML selectors for material configuration and initialize select2 for better look and feel.
   *
   * @param {jQueryElement} $container
   * @param {Design} design - can be the whole design or a part
   * @param {Array} texts - texts for selectors, optional. Overriden for laser cutting
   */
  PrintMaterialCollection.prototype.generateSelectors = function (
    $container,
    design,
    texts
  ) {
    if (!texts) {
      texts = this.defaultTexts;
    }

    var selectors = this.getSelectors(design);
    var mapvalue = this.getMapValue(
      design.material,
      design.order.finish,
      design.order.painting,
      design.order.options,
      design.order.color
    );
    // an unknown configuration (ex: not available to this user) must not
    // prevent the selectors from rendering, none is preselected then
    var currentMaterialMap = this.getMapIndex(mapvalue) || "";
    var currentProcess = currentMaterialMap
      ? currentMaterialMap.split(",")[0]
      : null;
    var swapper = null;
    // The infill is the last field of the front slug but is shown right after
    // the material, the way generateDashboard shows it. Every map that has an
    // infill field is concerned: metal filament and all the FDM materials.
    if (hasInfillField(currentMaterialMap)) {
      var infill = selectors.pop();
      selectors.splice(2, 0, infill);
      texts = texts.map(function (x) {
        return x;
      });
      var infill_text = texts.pop();
      texts.splice(2, 0, infill_text);
      swapper = {
        0: 0,
        1: 1,
        2: 5,
        3: 2,
        4: 3,
        5: 4,
      };
    }

    for (var i = 0; i < selectors.length; i++) {
      var selector = selectors[i];
      var j = swapper ? swapper[i] : i;
      var selectorName = texts[i][2];
      var $select = $('<select style="width:100%;">')
        .data("index", j)
        .attr("id", "select-" + selectorName);
      for (var value in selector) {
        if (selector.hasOwnProperty(value) && value) {
          var name = selector[value].name;
          // Show plated thickness if needed
          if (
            currentProcess in platedThickness &&
            value in platedThickness[currentProcess]
          ) {
            name += " (" + platedThickness[currentProcess][value] + ")";
          }
          var $option = $("<option>")
            .val(value)
            .text(name)
            .attr("title", selector[value].desc)
            .data("price", selector[value].price)
            .data("thumbnail", selector[value].thumbnail)
            .data("errors", selector[value].errors)
            .data("label", selector[value].label)
            // use for google tag manager
            .attr("data-selector-type", texts[i][2]);
          if (value === currentMaterialMap.split(",")[j]) {
            $option.attr("selected", "selected");
          }
          $option.appendTo($select);
        }
      }

      // code to add a message at the bottom of the color selector when the user select dyed/dyed polished or dyemansion in SLS
      // Epic:  WD-639, WD-640, WD-641

      // be sure that we have at least process/material/finish
      if (currentMaterialMap.split(",").length >= 3) {
        // list of finishes where we want the message to be shown
        // we need process/material/finish   because it has to be visible only in sls
        var finishesThatNeedContactLink = [
          "sls_plastic,nylon_pa12_100u,dyed",
          "sls_plastic,nylon_pa12_100u,dyed_polished",
          "sls_plastic,nylon_pa12_100u,dyemansion_outdoor",
          "sls_plastic,nylon_pa12_100u,dyemansion_lunettes",
        ];

        // build a string of only process/material/finish from the current material map
        var c =
          currentMaterialMap.split(",")[0] +
          "," +
          currentMaterialMap.split(",")[1] +
          "," +
          currentMaterialMap.split(",")[swapper ? swapper[2] : 2];
        // check if we match with our list of finishes
        if (finishesThatNeedContactLink.indexOf(c) !== -1) {
          // add the option in the selector ONLY for color
          if (texts[i][2] == "color") {
            var contact_us = gettext(
              "You need a color not listed above? <a href='/en/contact/?category=8' target='_blank'>Contact us</a> and we will find a solution together."
            );
            var $option = $("<option>")
              .val(null)
              .text(contact_us)
              .attr("disabled", "disabled")
              .data("custom", true); // use later to add class to that specific element in SELECT2
            $option.appendTo($select);
          }
        }
      }

      var $row = $("<div>").addClass("row");
      $("<h3>")
        .addClass("settings-title col _s4")
        .text(texts[i][0])
        .appendTo($row);
      $("<span>")
        .addClass("settings-guide col _s8 ")
        .attr("data-index", j)
        .text(texts[i][1])
        .appendTo($row)
        .prepend('<span class="icon-down-arrow"></span>');

      if ($select.find("option").length) {
        $row.appendTo($container);
        $select.appendTo($container);
      }
      // do not show varnish anymore (WD-2182), I am not completely sure
      // about the implication of not showing the selector anymore so I hide
      // it which leaves it at its initial value
      if (selectorName === "varnish") {
        $select.addClass("hidden");
        $row.addClass("hidden");
      }
    }

    this.initializeSelect2($container);
  };

  /**
   * Only used by PrintMaterialsView.js.
   *
   * @todo i'll like to move it
   */
  PrintMaterialCollection.prototype.generateDashboard = function (
    $processContainer,
    $materialsContainer,
    design
  ) {
    var texts = this.defaultTexts;
    var selectors = this.getSelectors(design);
    var materials = this.getAvailableMaterials(design);
    var currentMaterialMap = this.getMapIndex(
      this.getMapValue(
        design.material,
        design.order.finish,
        design.order.painting,
        design.order.options,
        design.order.color
      )
    );

    // mostly when the design is not available to print, currentMaterialMap will be null
    if (currentMaterialMap == null) {
      return;
    }

    var currentProcess = currentMaterialMap.split(",")[0];
    var currentMapSplit = currentMaterialMap.split(",");

    var optionsArray = [[], [], [], [], [], []];

    // All options available for currently selected process
    var optionsList = Object.keys(materials).filter(function (map) {
      return (
        map.indexOf(currentMaterialMap.split(",").slice(0, 1).join(",")) > -1
      );
    });

    // Building processes list
    Object.keys(materials).forEach(
      function (map) {
        var p = map.split(",")[0];
        if (optionsArray[0].indexOf(p) === -1) {
          optionsArray[0].push(p);
        }
      }.bind(this)
    );

    // Building options for current process
    optionsList.forEach(function (option) {
      option.split(",").forEach(function (opt, i) {
        if (i > 0 && optionsArray[i].indexOf(opt) === -1) {
          optionsArray[i].push(opt);
        }
      });
    });
    var infill = optionsArray.pop();
    optionsArray.splice(2, 0, infill);
    texts = texts.map(function (x) {
      return x;
    });
    var infill_text = texts.pop();
    texts.splice(2, 0, infill_text);
    var swapper = {
      0: 0,
      1: 1,
      2: 5,
      3: 2,
      4: 3,
      5: 4,
    };

    // Building UL elements
    for (var i = 0; i < optionsArray.length; i++) {
      var k = swapper[i];
      var $container = k === 0 ? $processContainer : $materialsContainer;
      var selectorName = texts[i][2];
      var $select = $("<ul>")
        .data("index", k)
        .attr("id", "ul-" + selectorName);
      var selector = optionsArray[i];
      for (var j in selector) {
        var value = selector[j];
        if (selector.hasOwnProperty(j) && value) {
          var translation = this.getTranslated(value);
          // We add plated thickness indication if needed
          if (
            currentProcess in platedThickness &&
            value in platedThickness[currentProcess]
          ) {
            translation += " (" + platedThickness[currentProcess][value] + ")";
          }
          var $option = $("<li>")
            .val(value)
            .text(translation)
            .attr("data-value", value)
            .attr("title", materialDescriptions[value] || "")
            .attr("data-selector-type", texts[i][2]);

          // Disabled materials
          if (disabledProcess.indexOf(value) !== -1) {
            $option.addClass("unavailable-material");
            $option.attr(
              "title",
              gettext(
                "Some of our materials are not available at the moment. We apologise for the inconvenience."
              )
            );
          }

          if (k === 1) {
            $option.append(
              $("<span>").addClass(
                "tile sprite sprite-" + materialThumbnails[value]
              )
            );
          } else if (k === 2 || k === 4 || k === 5) {
            $option.append(
              $("<span>").addClass(
                "tile sprite sprite-" + finishThumbnails[value]
              )
            );
          } else if (k === 3) {
            $option.append(
              $("<span>").addClass(
                "tile sprite sprite-" +
                  this.getColorThumbnail(currentProcess + "," + value)
              )
            );
          }

          // Mark as selected if necessary
          if (value === currentMaterialMap.split(",")[k]) {
            $option.addClass("selected");
          }

          // Mark as unavailable if the option is incompatible with the currently selected stuff
          if (
            !this.findClosestMap(
              currentMapSplit.slice(0, k).join(",") + "," + value,
              k
            )
          ) {
            var hintMessage = gettext(
              "This option is not available in this configuration. "
            );

            if (k === 2 || k === 3) {
              var valid = [];
              optionsList.forEach(function (opt) {
                opt = opt.split(",");
                if (opt[k] === value && valid.indexOf(opt[k - 1]) === -1) {
                  valid.push(opt[k - 1]);
                }
              });

              var hintMessageMaterial = gettext(
                "Consider using one of the following materials to use this finish: "
              );
              var hintMessageFinish = gettext(
                "Consider using one of the following finish to use this color: "
              );
              var hintMessagePainting = gettext(
                "Consider using one of the following materials to use this painting color: "
              );

              var color_exception = false;
              var suffix = valid
                .map(
                  function (m) {
                    var translated_m = this.getTranslated(m);
                    // Specify the material for Mirror Polished finish hint message
                    if (m === "mirror_polished") {
                      translated_m = gettext(
                        "Mirror Polished with Brass Material"
                      );
                    }
                    if (m === "painting" && currentProcess === "hp_plastic") {
                      translated_m = gettext("TPU");
                      color_exception = true;
                    }
                    return translated_m;
                  }.bind(this)
                )
                .join(", ");
            }
            if (k === 2) {
              hintMessage += hintMessageMaterial;
            } else if (k === 3) {
              if (color_exception) {
                hintMessage += hintMessagePainting;
              } else {
                hintMessage += hintMessageFinish;
              }
            }
            hintMessage += suffix;

            $option.addClass("error-not-available hint--top hint--large");
            $option.append($("<span>").addClass("icon-unavailable"));
            $option.attr("aria-label", hintMessage);
          }

          // Only for materials for now
          if (k === 1) {
            var tmpMap = this.findClosestMap(
              currentMapSplit.slice(0, k).join(",") + "," + value,
              k
            );
            var tmpInfos = this.getMaterialPaintingFinishFromMap(tmpMap);
            var material_availablity = this.isAvailable(
              tmpInfos.material,
              tmpInfos.finish,
              tmpInfos.painting,
              design
            );
            if (!material_availablity.available) {
              var hintMessage = gettext(material_availablity.msg);
              $option.addClass("error-size hint--top hint--large");
              $option.append($("<span>").addClass("icon-scale-issue"));
              $option.attr("aria-label", hintMessage);
            }
          }

          $option.appendTo($select);
        }
      }

      var $row = $("<div>", { id: "row" + texts[i][0] }).addClass("row");
      var $col = $("<div>").addClass("col _s12").appendTo($row);
      $("<h3>").addClass("settings-title").text(texts[i][0]).appendTo($col);
      if ($select.find("li").length) {
        $select.appendTo($col);
        $row.appendTo($container);
      }
      // do not show varnish anymore (WD-2182), I am not completely sure
      // about the implication of not showing the selector anymore so I hide
      // it which leaves it at its initial value
      if (selectorName === "varnish") {
        $select.addClass("hidden");
        $row.addClass("hidden");
      }
    }

    // Disabled process
    var sel = document.getElementById("select-process");
    for (var i = 0, n = sel.options.length; i < n; i++) {
      var value = sel.options[i].value;
      if (disabledProcess.indexOf(value) !== -1) {
        sel.options[i].disabled = true;
      }
    }
  };

  PrintMaterialCollection.prototype.getMapFromSelectors = function (
    $container,
    $select,
    selectorIndex
  ) {
    if (!selectorIndex && $select) {
      selectorIndex = $("select", $container).index($select);
    } else if (!selectorIndex) {
      selectorIndex = $("select", $container).length - 1;
    }
    var selection = $("select", $container).toArray();
    selection.sort(function (select_0, select_1) {
      return $(select_0).data("index") - $(select_1).data("index");
    });
    var materialMap = selection
      .map(function (select) {
        return $(select).val();
      })
      .filter(function (val) {
        return !!val;
      })
      .join(",");

    materialMap = this.findClosestMap(materialMap, selectorIndex);
    var materialConfig = this.getMaterialPaintingFinishFromMap(materialMap);

    return materialConfig;
  };

  /**
   * init select2.js
   * @private
   * @param {object} event
   */
  PrintMaterialCollection.prototype.initializeSelect2 = function (
    $container,
    select2Options
  ) {
    var $selects = $("select:not(.hidden)", $container);
    var options = $.extend(
      {
        minimumResultsForSearch: Infinity, //hide the search box
        dropdownParent: $container,
        templateSelection: this.renderSelect2Option.bind(this),
        templateResult: this.renderSelect2Option.bind(this),
      },
      select2Options || {}
    );
    $selects.select2(options);

    var $selects2 = $(".select2", $container);
    $selects2.each(function (index) {
      var $this = $(this);
      var hintText = $(this).find(".select2-selection__rendered").attr("title");
      $this
        .find(".select2-selection__arrow")
        .after(
          '<span class="select2-selection__hint hint--top-left hint--large" aria-label="' +
            hintText +
            '"><span class="select2-selection__hint-icon"></span></span>'
        );
    });
  };

  /**
   * Renders Select2 content line.
   *
   * @param {object} data
   */
  PrintMaterialCollection.prototype.renderSelect2Option = function (data) {
    var $el = $("<p>").addClass("clearfix relative");
    var $title = $("<span>"),
      $content = $("<span>"),
      $price = $("<span>");
    var thumbnail = $(data.element).data("thumbnail");
    var price = $(data.element).data("price");
    var errors = $(data.element).data("errors");
    var isCustom = $(data.element).data("custom");
    var title_plating_thikness;
    var currentMaterialMap = this.getCurrentMaterialMap();
    var currentProcess = currentMaterialMap
      ? currentMaterialMap.split(",")[0]
      : null;

    if (thumbnail) {
      $content.addClass("select2-selection__content");
      $content.prepend(
        $("<div>")
          .addClass("tile sprite sprite-" + thumbnail)
          .attr("data-material-preview", thumbnail)
      );
    } else if (isCustom) {
      $title.addClass("select2-selection__title--no-margin-left");
    }
    $title.addClass("select2-selection__title");
    $title.html(data.text);
    // Specify plated thickness tooltip if needed
    if (
      currentProcess in platedThickness &&
      data.id in platedThickness[currentProcess]
    ) {
      title_plating_thikness =
        platedThickness[currentProcess][data.id] +
        gettext(" is the available plating thickness for this material");
    }
    if (title_plating_thikness) {
      $title.append(
        '<span style="font-family: icomoon !important; color: darkgrey; font-size: 1.8rem;" title="' +
          title_plating_thikness +
          '"> &#xe925;</span>'
      );
    }
    $title.append($price);
    $price.addClass("select2-selection__price");
    // force the price in the selector to display a loader
    // otherwise display the price or an error
    if (this.is_fetching_all_materials) {
      $price.html(
        '<div><span class="loading-circle loading-circle--small"></span><span class="select2-selection__price-loading">' +
          gettext("Loading price") +
          "</span></div>"
      );
    } else if (price == "marketplace_product_null") {
      //small hack only for the product in marketplace
      //the selector on that page is different and we do not have much place for a long sentence
      $price.html(gettext("Not available"));
    } else if (price) {
      price = this.controller.formatPrice(price);
      // Disabled materials
      if (disabledProcess.indexOf(data.id) !== -1) {
        $price.html(
          '<span class="select2-selection__price-from">' +
            '</span><span class="select2-selection__price-value"> ' +
            gettext("Temporarily unavailable") +
            "</span>"
        );
      } else {
        $price.html(
          '<span class="select2-selection__price-from">' +
            gettext("from") +
            '</span><span class="select2-selection__price-value"> ' +
            price +
            "</span>"
        );
      }
    } else if (price === null) {
      $price.html(gettext("Not available with this settings"));

      // show errors for debugging
      if (window.sculpteo.debug == "2") {
        // Show errors in the array when debug = 2
        $title.append(
          '<span class="select2-selection__hint hint--top hint--large" aria-label="' +
            errors +
            '"><span class="select2-selection__hint-icon"></span></span>'
        );
      }
    }

    this.addLabel($title, data);

    $el.append($title).append($content);
    return $el;
  };

  /**
   * Add specific label in select for process and materials
   */
  PrintMaterialCollection.prototype.addLabel = function ($title, data) {
    var label = $(data.element).data("label");

    var renderLabel = function (label, label_type, title) {
      $title.append(
        $("<span>")
          .addClass("select2-selection__label")
          .addClass(label_type)
          .attr("title", title)
          .html(label)
      );
    };

    var betaSlugs = [
      "rg_3280",
      "st_45",
      "fused_filament_fabrication",
      "r_pet",
      "petg_esd",
      "stainless_steel_316l",
    ];

    var bioSourcedSlugs = ["pa11_sls", "pa11_hp"];

    var promotedSlugs = ["nylon_pa12_100u"];

    var versatileSlugs = ["pa12_s"];

    var recyclableSlugs = ["polypropylene_hp"];

    var staffSlugs = [];

    var devSlugs = [];

    var foodContactSlugs = ["pa11_sls", "food_grade_pa12_blue"];

    // recyclable label
    if (recyclableSlugs.indexOf(data.id) !== -1) {
      renderLabel(
        gettext("Recyclable"),
        "label-recyclable",
        gettext("polypropylene_recyclable_title")
      );
    }
    // bio-sourced label
    if (bioSourcedSlugs.indexOf(data.id) !== -1) {
      renderLabel(
        undefined,
        "label-biosourced",
        // Fix percent character issue https://stackoverflow.com/questions/33023122/django-translation-escape-sign
        /* xgettext: no-javascript-format */
        gettext("PA11 is a biosourced material, coming from 100% castor oil.")
      );
    }

    // food contact label
    if (foodContactSlugs.indexOf(data.id) !== -1) {
      renderLabel(
        undefined,
        "label-food-contact",
        gettext(
          "Suitable for food contact according to Regulation (EC) No 1935/2004, and Code of Federal Regulations Food and Drugs Title 21- 2017 - §177.1500."
        )
      );
    }
    // food contact label only for Nylon PA11 raw
    if (
      (this.currentDesign === null &&
        $("#select-process option:selected").text().includes("SLS") &&
        $("#select-material option:selected").text() == "Nylon PA11") ||
      (this.currentDesign &&
        $(data.element).parents(
          '[data-uuid="' + this.currentDesign.model_uuid + '"]'
        ).length > 0 &&
        this.currentDesign.currentMaterial.indexOf("pa11_sls,raw") !== -1)
    ) {
      // print or multi print page
      // For now this only work for the first item in the multi print page
      if (data.id && data.id.indexOf("raw") !== -1) {
        renderLabel(
          undefined,
          "label-food-contact",
          gettext(
            "Suitable for food contact according to Regulation (EC) No 1935/2004, and Code of Federal Regulations Food and Drugs Title 21- 2017 - §177.1500."
          )
        );
      }
    }

    // sculpteo only labels (i.e not using the basf theme)
    if (data.id && !window.theme) {
      // beta label
      if (betaSlugs.indexOf(data.id) !== -1) {
        renderLabel(gettext("Beta"), "label-beta");
      }
      // promoted label
      if (promotedSlugs.indexOf(data.id) !== -1) {
        renderLabel(gettext("Our Bestseller"), "label-promoted");
      }
      // versatile label
      if (versatileSlugs.indexOf(data.id) !== -1) {
        renderLabel(gettext("Most versatile"), "label-promoted");
      }
      // staff label
      if (staffSlugs.indexOf(data.id) !== -1 || label == "staff") {
        renderLabel(gettext("Staff"), "label-staff");
      }
      // dev label
      if (devSlugs.indexOf(data.id) !== -1) {
        renderLabel(gettext("Dev"), "label-dev");
      }
    }
  };

  /**
   * Returns materials, filtered by the design's production_center
   */
  PrintMaterialCollection.prototype.getAvailableMaterials = function (design) {
    var materials = materialMap;

    if (design) {
      materials = this.filterMaterialMapByShippingSite(
        materials,
        design.order.production_center
      );
    }

    return materials;
  };

  /**
   * Selector generation rules:
   * - 1st selector (Families) always display ALL materials families
   * - 2nd selector (Material) displays all materials from the current familly
   * - 3rd selector (Finish) displays all finishes from the selected materials
   * - 4th selector (Color) displays all colors from the selected finish
   * - 5th selector (Varnish) displays all varnish from previous
   */
  PrintMaterialCollection.prototype.getSelectors = function (design) {
    var selectors = [];
    if (
      design.material.slug === "prototyping_resin_white_formlabs" &&
      !design.order.finish &&
      !design.order.painting
    ) {
      design.order.finish = "hand_polished"; // default finish for SLA (Cf. WD-3262)
    }
    var currentMaterialMap = this.getMapIndex(
      this.getMapValue(
        design.material,
        design.order.finish,
        design.order.painting,
        design.order.options,
        design.order.color
      )
    );

    // Multi print has multiple designs, which each have a current material map
    design.currentMaterial = currentMaterialMap;

    var materials = this.getAvailableMaterials(design);
    var nbSelectors = 6;

    for (var i = 0; i < nbSelectors; i++) {
      var selector = this.getSelector(i, currentMaterialMap, materials, design);
      if (selector) {
        selectors.push(selector);
      }
    }

    return selectors;
  };

  /**
   * Filters materials map by shipping site.
   * For now, only used for laser cutting, but it can be extended to 3D materials someday
   *
   * @param {object} map of materials (see materialMap)
   * @param {Number} shipping_site
   * @return {object}
   */
  PrintMaterialCollection.prototype.filterMaterialMapByShippingSite = function (
    materials,
    shipping_site
  ) {
    if (!shipping_site || !parseInt(shipping_site, 10)) {
      return materials;
    }

    var filtered = {};

    for (var i in materials) {
      if (materials.hasOwnProperty(i)) {
        var properties = this.getMaterialPaintingFinishFromMap(i, false);
        if (properties.material.shipping_site === parseInt(shipping_site, 10)) {
          filtered[i] = materials[i];
        }
      }
    }

    return filtered;
  };

  /**
   * Check if material is available (present in material prices after a get_price request, without errors)
   * @param {string} material
   * @param {string} finish
   * @param {string} painting
   * @return {bool}
   */
  PrintMaterialCollection.prototype.isAvailable = function (
    material,
    finish,
    painting,
    design
  ) {
    if (!this.priceMap || !Object.keys(this.priceMap).length) {
      return { available: true, msg: "" };
    }
    if (!design) {
      design = this.design;
    }

    var data = this.getPricesForMaterial(material, design);
    var message;

    if (!data || data.error) {
      message = data && data.error ? data.error : "No price for this material";
      return { available: false, msg: message };
    }

    if (
      finish &&
      (!data.options.finish ||
        !data.options.finish[finish] ||
        data.options.finish[finish].errors ||
        data.options.finish[finish].error)
    ) {
      if (data.options.finish) {
        message =
          data.options.finish[finish].errors ||
          data.options.finish[finish].error;
      } else {
        message = "Finish not available";
      }
      return { available: false, msg: message };
    }
    if (
      painting &&
      (!data.options.painting ||
        !data.options.painting[painting] ||
        data.options.painting[painting].errors ||
        data.options.painting[painting].error)
    ) {
      if (data.options.painting) {
        message =
          data.options.painting[painting].errors ||
          data.options.painting[painting].error;
      } else {
        message = "Option not available";
      }
      return { available: false, msg: message };
    }

    return { available: true, msg: message };
  };

  /**
   * Compute the lowest price for the corresponding map in available materials
   * @private
   * @param {string} map (ex: "sls_plastic")
   * @return int
   */
  PrintMaterialCollection.prototype.getLowestPrice = function (map, design) {
    design = design || this.design;
    var materials = this.getAvailableMaterials(design);
    var selection = {};
    var lowestPrice = null;
    var errors = [];
    var m;

    if (!this.priceMap) {
      return;
    }

    for (m in materials) {
      if (materials.hasOwnProperty(m) && m.indexOf(map) > -1) {
        selection[m] = materials[m];
      }
    }

    for (m in materials) {
      if (selection.hasOwnProperty(m)) {
        var properties = this.getMaterialPaintingFinishFromMap(m);
        var data = this.getPricesForMaterial(properties.material, design);

        if (data && data.error) {
          if (errors.indexOf(data.error) == -1) errors.push(data.error);
        }

        var material_availablity = this.isAvailable(
          properties.material,
          properties.finish,
          properties.painting,
          design
        );
        if (!data || !material_availablity.available) {
          continue;
        }

        var price = data.price.unit_price;

        // Handling options
        if (properties.finish) {
          price += data.options.finish[properties.finish].price_delta;
        }
        if (properties.painting) {
          price += data.options.painting[properties.painting].price_delta;
        }

        // Economy mode is always without options. Replace de previous price
        if (
          !properties.finish &&
          !properties.painting &&
          data.options &&
          data.options.economy_mode &&
          data.options.economy_mode.unit_price
        ) {
          price = data.options.economy_mode.unit_price;
        }

        if (!lowestPrice || price < lowestPrice) {
          lowestPrice = price;
        }
      }
    }
    return { price: lowestPrice, errors: errors };
  };

  PrintMaterialCollection.prototype.getColorThumbnail = function (map) {
    // Lookup for color thumbnails using regexp (less configuration)
    for (var i in colorThumbnails) {
      if (colorThumbnails.hasOwnProperty(i)) {
        var re = new RegExp(i);
        if (re.test(map)) {
          return colorThumbnails[i];
        }
      }
    }
  };

  PrintMaterialCollection.prototype.getMaterialThumbnail = function (material) {
    if (materialThumbnails[material]) {
      return materialThumbnails[material];
    }
  };

  PrintMaterialCollection.prototype.getMaterialDescription = function (key) {
    return materialDescriptions[key];
  };

  PrintMaterialCollection.prototype.getMaterialUrl = function (key) {
    return materialUrls[key] || "";
  };

  PrintMaterialCollection.prototype.getSelector = function (
    selectorIndex,
    currentMaterialMap,
    materialMap,
    design
  ) {
    var selector = {};
    var selectorHasOptions = false;
    currentMaterialMap = currentMaterialMap || "";
    var options = Object.keys(materialMap).filter(function (map) {
      return (
        map.indexOf(
          currentMaterialMap.split(",").slice(0, selectorIndex).join(",")
        ) > -1
      );
    });

    options.forEach(
      function (pair) {
        var map = pair;
        pair = pair.split(",");
        if (
          pair.length - 1 >= selectorIndex &&
          Object.keys(selector).indexOf(pair[selectorIndex]) === -1
        ) {
          selector[pair[selectorIndex]] = {
            name: this.getTranslated(pair[selectorIndex]),
            desc:
              selectorIndex < 3
                ? materialDescriptions[pair[selectorIndex]] || ""
                : "",
            thumbnail: null,
            label: this.getOptionLabel(map),
          };

          if (selectorIndex == 1 && materialThumbnails[pair[selectorIndex]]) {
            selector[pair[selectorIndex]].thumbnail = this.getMaterialThumbnail(
              pair[selectorIndex]
            );
          } else if (
            this.controller.controllerType == "2D" &&
            selectorIndex == 2
          ) {
            selector[pair[selectorIndex]].thumbnail =
              materialThumbnails[pair[selectorIndex]];
          } else if (selectorIndex == 3) {
            selector[pair[selectorIndex]].thumbnail =
              this.getColorThumbnail(map);
          } else if (selectorIndex == 5) {
            selector[pair[selectorIndex]].thumbnail =
              finishThumbnails[pair[selectorIndex]];
          }

          var priceOrErrors = this.getLowestPrice(
            pair.slice(0, selectorIndex + 1).join(","),
            design
          );
          selector[pair[selectorIndex]].price = priceOrErrors.price;
          selector[pair[selectorIndex]].errors =
            priceOrErrors.errors.length > 0 ? priceOrErrors.errors : null;
          selectorHasOptions = true;
        }
      }.bind(this)
    );

    return selectorHasOptions ? selector : null;
  };

  PrintMaterialCollection.prototype.getTranslated = function (
    mapPart,
    useLong
  ) {
    var translation = materialTranslations[mapPart] || mapPart;

    if (
      useLong &&
      materialTranslationsLong &&
      materialTranslationsLong[mapPart]
    ) {
      translation = materialTranslationsLong[mapPart];
    }
    return translation;
  };

  /**
   * Get the material configuration from the selected informations
   * Ex: 'black_plastic,finish=vernish_matte'
   *
   * The options are listed the way index.html lists them, by decreasing category
   * name, so that the configuration of a selection is the very string the
   * material map is keyed by.
   *
   * @param {Material} material
   * @param {string} finish
   * @param {string} painting
   * @param {Array} options
   * @param {string} color - option key of the color, for the materials that are
   *   sold in several ones. Ex: 'color_black'
   * @return {string}
   */
  var getMapValue = (scope.getMapValue = function (
    material,
    finish,
    painting,
    options,
    color
  ) {
    if (!material) return;
    var string = material.slug;

    // Add default 20% infill finish for rPET if not specified
    if ((string === "r_pet_clear_blue" || string === "petg_esd") && !finish) {
      finish = "infill_20";
    }

    if (painting) {
      string += ",painting=" + painting;
    }
    if (finish) {
      string += ",finish=" + finish;
    }

    if (options && options.length == 1) {
      string += ",production_mode=" + options[0];
    }
    if (color) {
      string += ",color=" + color;
    }

    return string;
  });

  PrintMaterialCollection.prototype.getMapValue = function (
    material,
    finish,
    painting,
    options,
    color
  ) {
    return getMapValue(material, finish, painting, options, color);
  };

  /**
   * Get the material map corresponding to the material configuration
   * Ex: 'sls_plastic,nylon_pa12_100u,dyed,black,none'
   * @param {string} value - Ex: 'black_plastic'
   * @return {string}
   */
  PrintMaterialCollection.prototype.getMapIndex = function (value) {
    return Object.keys(materialMap)[Object.values(materialMap).indexOf(value)];
  };

  /**
   * The fields of a material map that have a value, as a comparable string.
   * Ex: 'fused_filament_fabrication,fdm_pla,raw,black,,infill_20' gives
   * 'fused_filament_fabrication,fdm_pla,raw,black,infill_20'.
   *
   * @param {string} map
   * @return {string}
   */
  var filledFields = function (map) {
    return map
      .split(",")
      .filter(function (field) {
        return !!field;
      })
      .join(",");
  };

  /**
   * Find the closest material configuration. Used when changing something in the material
   * selectors, allows us to find the "default" material.
   * Ex: When we are in multicolor, the map is "binder_jetting_multicolor,composite,multicolor,raw". If
   * we change the material family, the map becomes "clip_resin,composite,multicolor,raw", that doesn't
   * exists. The good thing to present is "clip_resin,prototyping_acrylate,raw,white".
   *
   * @param {string} map
   * @param {string} index of the changed selector to prevents inconsistent results.
   * @return {string}
   */
  PrintMaterialCollection.prototype.findClosestMap = function (map, index) {
    //we need to use the available materials on the design and not all materials
    //it is use for lasercut when changing the production center
    var maps = Object.keys(this.getAvailableMaterials(design));

    var partial = map
      .split(",")
      .slice(0, index + 1)
      .join(",");

    if (maps.indexOf(map) > -1) {
      return map;
    }

    // A map rebuilt from the selectors only carries the fields that have a
    // value: an empty field of the front slug has no selector to be read from,
    // so it is simply missing from the map. Every FDM material drops the
    // varnish field that way ("...,raw,black,infill_20" instead of
    // "...,raw,black,,infill_20"), metal filament drops the color one too.
    // Match on the filled fields to find the front slug the map stands for.
    var filled = filledFields(map);
    var aligned = maps.filter(function (key) {
      return filledFields(key) === filled;
    });
    if (aligned.length) {
      return aligned[0];
    }

    // Try to match e.g. "sls_plastic,pa11_sls,raw,white" with "sls_plastic,pa11_sls,raw,white,none"
    let match = maps.filter((key) => key.startsWith(map));
    if (match.length) {
      return match[0];
    }

    if (partial in defaultMaterialMap) {
      var map = defaultMaterialMap[partial];
      if (maps.indexOf(map) > -1) {
        return map;
      }
    }

    for (var i = 0; i < maps.length; i++) {
      if (maps[i].indexOf(partial) > -1) {
        return maps[i];
      }
    }

    return null;
  };

  /**
   * Get material, finish, painting and color from material map
   * @param {string} map. Ex 'binder_jetting_multicolor,composite,multicolor,raw'
   * @return {object}
   */
  PrintMaterialCollection.prototype.getMaterialPaintingFinishFromMap =
    function (map, raw) {
      var materialConfig = materialMap[map];
      var material = materialConfig.split(",")[0];
      var finish, painting, color;

      // Material
      if (!raw) {
        for (var k in this.design.order.materials) {
          if (this.design.order.materials[k].slug === material) {
            material = this.design.order.materials[k];
            break;
          }
        }
      }

      // Extract finish, painting and color
      var regexpFinish = /.*finish=([\w_]*),?/;
      var regexpPainting = /.*painting=([\w_]*),?/;
      var regexpColor = /.*color=([\w_]*),?/;

      if (regexpFinish.test(materialConfig)) {
        finish = materialConfig.match(regexpFinish)[1];
      }
      if (regexpPainting.test(materialConfig)) {
        painting = materialConfig.match(regexpPainting)[1];
      }
      if (regexpColor.test(materialConfig)) {
        color = materialConfig.match(regexpColor)[1];
      }

      // TODO Do away with regex
      // I need to find a better way to do all of this but I am using this as a prototype
      // to fix the rest before
      var options = [];
      var regexOptions = /.*production_mode=([\w_]*),?/;
      if (regexOptions.test(materialConfig)) {
        options = [materialConfig.match(regexOptions)[1]];
      }

      return {
        material: material,
        finish: finish,
        painting: painting,
        color: color,
        options: options,
      };
    };

  //use in lasercut for the production mode center
  PrintMaterialCollection.prototype.getGroupByProductSlug = function (slug) {
    for (var i in materialMap) {
      if (materialMap.hasOwnProperty(i)) {
        if (materialMap[i].indexOf(slug) > -1) {
          return i.split(",")[0];
        }
      }
    }

    return null;
  };

  PrintMaterialCollection.prototype.getOptionLabel = function (combos) {
    var label = null;
    var staffCombos = [];

    if (staffCombos.indexOf(combos) !== -1) label = "staff";
    return label;
  };
})((window.sculpteo = window.sculpteo || {}));
